// src/components/NativeAdCard.tsx
import React from 'react';
import RoddoAdSlot from './RoddoAdSlot';

type NativeAdCardProps = {
  slotId: string;
  className?: string;
  label?: string;
};

export default function NativeAdCard(props: NativeAdCardProps) {
  return <RoddoAdSlot {...props} placement="baleen-bay-feed" />;
}
